/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequestAutocompleteSuggestion } from './APIGuestRequestAutocompleteSuggestion';
import {
    APIGuestRequestAutocompleteSuggestionFromJSON,
    APIGuestRequestAutocompleteSuggestionFromJSONTyped,
    APIGuestRequestAutocompleteSuggestionToJSON,
} from './APIGuestRequestAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIGuestRequestAutocompleteResponse
 */
export interface APIGuestRequestAutocompleteResponse {
    /**
     * 
     * @type {Array<APIGuestRequestAutocompleteSuggestion>}
     * @memberof APIGuestRequestAutocompleteResponse
     */
    suggestions: Array<APIGuestRequestAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIGuestRequestAutocompleteResponse interface.
 */
export function instanceOfAPIGuestRequestAutocompleteResponse(value: object): value is APIGuestRequestAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIGuestRequestAutocompleteResponseFromJSON(json: any): APIGuestRequestAutocompleteResponse {
    return APIGuestRequestAutocompleteResponseFromJSONTyped(json, false);
}

export function APIGuestRequestAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIGuestRequestAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIGuestRequestAutocompleteResponseToJSON(value?: APIGuestRequestAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIGuestRequestAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

